const prefixApiV2 = '/v2'
const prefixAdminApiV1 = '/v1/admin'
const prefixAdminApiV2 = '/v2/admin'

// auth
export const apiLogin = `${prefixApiV2}/public/auth/sign-in`
export const apiForgotPassword = `${prefixApiV2}/public/auth/forgot-password`
export const apiResetPassword = `${prefixApiV2}/public/auth/reset-password/:id`
export const apiLoginGoogle = `${prefixApiV2}/public/auth/sign-in/google`
export const apiSignUp = `${prefixApiV2}/public/auth/sign-up`
export const apiValidateInvitation = `${prefixApiV2}/public/users/validate-invitation`
export const apiSubmitInvitation = `${prefixApiV2}/public/users/submit-invitation`
export const apiPublicUsersId = `${prefixApiV2}/public/users/:id`
export const apiSignOut = `${prefixApiV2}/public/auth/sign-out`

// review
export const apiPublicReviewsId = `${prefixApiV2}/public/reviews/:id`
export const apiAdminReviewsOverallId = `${prefixAdminApiV2}/reviews/overall/:id`

// users
export const apiAdminUsersId = `${prefixAdminApiV2}/users/:id`
export const apiAdminUsersIdRates = `${prefixAdminApiV2}/users/:id/rates`
export const apiAdminUsersIdReactivate = `${prefixAdminApiV2}/users/:id/reactivate`
export const apiProfile = `${prefixAdminApiV2}/users/profile`
export const apiUsersTours = `${prefixAdminApiV2}/users/tours`
export const apiPasswordSecurity = `${prefixAdminApiV2}/users/password-security`
export const apiUsers = `${prefixAdminApiV2}/users`
export const apiUserResentInvitation = `${prefixAdminApiV2}/users/resent-invitation`
export const apiInviteUser = `${prefixAdminApiV2}/users/invite`
export const apiUsersBranch = `${prefixAdminApiV2}/branches/:branch/users`
export const apiUsersCompleteProfile = `${prefixAdminApiV2}/users/complete-profile`

// onboarding
export const apiOnboardingCompanyName = `${prefixAdminApiV2}/onboarding/company-name`
export const apiOnboardingCompanyLocation = `${prefixAdminApiV2}/onboarding/company-location`
export const apiOnboardingCompanyCategory = `${prefixAdminApiV2}/onboarding/company-category`
export const apiOnboardingCompanyDetail = `${prefixAdminApiV2}/onboarding/company-details`
export const apiOnboardingCompanyMainBranch = `${prefixAdminApiV2}/onboarding/company-main-branch`
export const apiOnboardingCompanyProfile = `${prefixAdminApiV2}/onboarding/company-profile`

// category
export const apiCategory = `${prefixAdminApiV2}/branches/:branch/categories`
export const apiCategoryId = `${prefixAdminApiV2}/branches/:branch/categories/:id`
export const apiCategorySequence = `${prefixAdminApiV2}/branches/:branch/categories/sequence`

// options
export const apiOptionsCompanyCategories = `${prefixAdminApiV2}/options/company-categories`
export const apiOptionsCompanySizes = `${prefixAdminApiV2}/options/company-sizes`
export const apiOptionsServiceTypes = `${prefixAdminApiV2}/options/service-types`

// branches
export const apiBranchesMe = `${prefixAdminApiV2}/branches/me`
export const apiBranches = `${prefixAdminApiV2}/branches`
export const apiBranchesSlug = `${prefixAdminApiV2}/branches/:branch`
export const apiBranchesGeneralInfo = `${prefixAdminApiV2}/branches/:branch/general-info`
export const apiBranchesPayment = `${prefixAdminApiV2}/branches/:branch/payment`
export const apiBranchesOperationTime = `${prefixAdminApiV2}/branches/:branch/operation-time`
export const apiBranchesLocation = `${prefixAdminApiV2}/branches/:branch/location`

// roles
export const apiRolePermissions = `${prefixAdminApiV2}/roles/permissions`
export const apiRoles = `${prefixAdminApiV2}/roles`
export const apiRolesMe = `${prefixAdminApiV2}/roles/me`

// service
export const apiServicesItemsId = `${prefixAdminApiV2}/services/items/:id`
export const apiService = `${prefixAdminApiV2}/branches/:branch/services`
export const apiServiceSequence = `${prefixAdminApiV2}/branches/:branch/services/sequence`
export const apiServiceUsers = `${prefixAdminApiV2}/services/users/:id`
export const apiServiceId = `${prefixAdminApiV2}/services/:id`
export const apiServiceBranchId = `${prefixAdminApiV2}/branches/:branch/services/:id`
export const apiServicePhotosUpload = `${prefixAdminApiV2}/services/photos/upload`

// schedule
export const apiScheduleShift = `${prefixAdminApiV2}/branches/:branch/schedules/shift/:userId`
export const apiScheduleShiftDay = `${prefixAdminApiV2}/branches/:branch/schedules/shift/:userId/day`
export const apiScheduleShiftDayDelete = `${prefixAdminApiV2}/branches/:branch/schedules/shift/:userId/delete`
export const apiSchedule = `${prefixAdminApiV2}/branches/:branch/schedules`
export const apiSchedulesRaws = `${prefixAdminApiV2}/branches/:branch/schedules/raws`

// clients
export const apiClients = `${prefixAdminApiV2}/clients`
export const apiClientsBirthdays = `${prefixAdminApiV2}/clients/birthdays`
export const apiClientsExport = `${prefixAdminApiV2}/clients/export`
export const apiClientsId = `${prefixAdminApiV2}/clients/:id`
export const apiClientsIdSales = `${prefixAdminApiV2}/clients/:id/sales`
export const apiClientsIdEmail = `${prefixAdminApiV2}/clients/:id/email`
export const apiClientsWalletsHistories = `${prefixAdminApiV2}/clients/wallets/histories/:clientId`
export const apiClientsWalletsBatches = `${prefixAdminApiV2}/clients/:id/wallets/batches`
export const apiClientsWalletsBatchesId = `${prefixAdminApiV2}/clients/:id/wallets/batches/:batchId`

// company
export const apiCompanyOnlineBookConfig = `${prefixAdminApiV2}/company/online-book/config`
export const apiCompanyOnlineBookConfigV2 = `${prefixAdminApiV2}/company/online-booking/config`
export const apiCompanyBillingsConfig = `${prefixAdminApiV2}/company/billings/config`
export const apiCompanyAuditLogsInvoice = `${prefixAdminApiV2}/company/audit-logs/invoices`

// transaction
export const apiTransactionsId = `${prefixAdminApiV2}/branches/:branch/transactions/:id`
export const apiTransactionsIdNotes = `${prefixAdminApiV2}/branches/:branch/transactions/:id/notes`
export const apiTransactionsIdDownpayments = `${prefixAdminApiV2}/branches/:branch/transactions/:id/downpayments`
export const apiTransactionsItems = `${prefixAdminApiV2}/branches/:branch/transactions/items`
export const apiTransactionsActivity = `${prefixAdminApiV2}/branches/:branch/transactions/:id/activity`

export const apiAppointments = `${prefixAdminApiV2}/branches/:branch/appointments`
export const apiAppointmentsId = `${prefixAdminApiV2}/branches/:branch/appointments/:id`
export const apiTransactionsItemId = `${prefixAdminApiV2}/branches/:branch/transactions/item/:id`
export const apiTransactionsSplit = `${prefixAdminApiV2}/branches/:branch/transactions/split`
export const apiTransactionsItemIdVoid = `${prefixAdminApiV2}/branches/:branch/transactions/:id/void`

export const apiTransactionsIdStatus = `${prefixAdminApiV2}/branches/:branch/transactions/:id/status`
export const apiTransactionsIdCancel = `${prefixAdminApiV2}/branches/:branch/transactions/:id/cancel`
export const apiTransactionsReadyCheckout = `${prefixAdminApiV2}/branches/:branch/transactions/ready-checkout`
// sales
export const apiSales = `${prefixAdminApiV2}/branches/:branch/sales`
export const apiSalesVouchers = `${prefixAdminApiV2}/branches/:branch/sales/vouchers`
export const apiSalesUpcoming = `${prefixAdminApiV2}/branches/:branch/sales/upcoming`
export const apiSalesInvoices = `${prefixAdminApiV2}/branches/:branch/sales/invoices/:id`

// sales public
export const apiPublicSalesInvoices = `${prefixApiV2}/public/sales/invoices/:id`

// clients
export const apiPaymentTypes = `${prefixAdminApiV2}/payment-types`
export const apiPaymentTypesId = `${prefixAdminApiV2}/payment-types/:id`
export const apiPaymentTypesSequence = `${prefixAdminApiV2}/payment-types/sequence`

//report
export const apiReportTips = `${prefixAdminApiV2}/branches/:branch/reports/tips`
export const apiReportCommissions = `${prefixAdminApiV2}/branches/:branch/reports/commissions`
export const apiReportSales = `${prefixAdminApiV2}/branches/:branch/reports/sales`
export const apiReportSalesLog = `${prefixAdminApiV2}/branches/:branch/reports/sales-log`
export const apiReportCommissionsMe = `${prefixAdminApiV2}/branches/:branch/reports/commissions/me`

//insight
export const apiInsight = `${prefixAdminApiV2}/branches/:branch/insight`

// deals
export const apiDeals = `${prefixAdminApiV2}/branches/:branch/deals`
export const apiDealsId = `${prefixAdminApiV2}/branches/:branch/deals/:id`
export const apiDealId = `${prefixAdminApiV2}/deals/:id`
export const apiDealsIdStatus = `${prefixAdminApiV2}/branches/:branch/deals/:id/status`

// billings
export const apiBillings = `${prefixAdminApiV2}/billings`
export const apiBillingsOutstanding = `${prefixAdminApiV2}/billings/outstanding`
export const apiBillingsId = `${prefixAdminApiV2}/billings/:id`
export const apiBillingsIdValidates = `${prefixAdminApiV2}/billings/:id/validates`

// block time
export const apiBlockTimesType = `${prefixAdminApiV2}/block-times/type`
export const apiBlockTimesTypeId = `${prefixAdminApiV2}/block-times/type/:id`
export const apiBlockTimes = `${prefixAdminApiV2}/branches/:branch/block-times`
export const apiBlockTimesId = `${prefixAdminApiV2}/branches/:branch/block-times/:id`

// package
export const apiPackagesClients = `${prefixAdminApiV2}/packages/clients/:clientUserId`
export const apiPackages = `${prefixAdminApiV2}/packages`
export const apiPackagesId = `${prefixAdminApiV2}/packages/:id`
export const apiPackagesPurchasedId = `${prefixAdminApiV2}/packages/purchased/:id`

// notification
export const apiNotificationsSubscribes = `${prefixAdminApiV2}/notifications/subscribes`
export const apiBranchNotificationConfig = `${prefixAdminApiV2}/branches/:branch/notification`

// product
export const apiProducts = `${prefixAdminApiV2}/products`
export const apiProductsIdSales = `${prefixAdminApiV2}/products/:id/sales`
export const apiProductsIdStockAdd = `${prefixAdminApiV2}/products/:id/stocks/add`
export const apiProductsIdStockOrders = `${prefixAdminApiV2}/products/:id/stocks/orders`
export const apiProductsIdStockRemove = `${prefixAdminApiV2}/products/:id/stocks/remove`
export const apiProductsIdStockHistories = `${prefixAdminApiV2}/products/:id/stocks/histories`
export const apiProductsPhotosUpload = `${prefixAdminApiV2}/products/photos/upload`
export const apiProductsPhotosUploadId = `${prefixAdminApiV2}/products/photos/upload/:id`
export const apiProductsId = `${prefixAdminApiV2}/products/:id`
export const apiProductsBrands = `${prefixAdminApiV2}/products/brands`
export const apiProductsBrandsId = `${prefixAdminApiV2}/products/brands/:id`

export const apiProductsCategories = `${prefixAdminApiV2}/products/categories`
export const apiProductsCategoriesId = `${prefixAdminApiV2}/products/categories/:id`
export const apiProductsIdCommission = `${prefixAdminApiV2}/products/:productId/commissions`
export const apiProductsCommission = `${prefixAdminApiV2}/products/commissions`

export const apiWhatsappsSessions = `${prefixAdminApiV2}/whatsapps/sessions`
export const apiWhatsappsReminderConfig = `${prefixAdminApiV2}/whatsapps/reminders/config`
export const apiWhatsappsSessionsId = `${prefixAdminApiV2}/whatsapps/sessions/:session`
export const apiWhatsappsSessionStatus = `${prefixAdminApiV2}/whatsapps/sessions/:session/status`
export const apiWhatsappsSessionsAuthQr = `${prefixAdminApiV2}/whatsapps/sessions/:session/auth/qr`
export const apiWhatsappsSessionsAuthRequestCode = `${prefixAdminApiV2}/whatsapps/sessions/:session/auth/request-code`
export const apiWhatsappsSessionsBranches = `${prefixAdminApiV2}/whatsapps/sessions/branches`
export const apiBranchWhatsappsTemplate = `${prefixAdminApiV2}/branches/:branch/whatsapps-template`
export const apiWhatsappsTemplateType = `${prefixAdminApiV2}/branches/:branch/whatsapps-template/:type`

// tax
export const apiTaxesRates = `${prefixAdminApiV2}/taxes/rates`
export const apiTaxesRatesId = `${prefixAdminApiV2}/taxes/rates/:id`

export const apiBranchTaxesRates = `${prefixAdminApiV2}/branches/:branch/taxes/rates`

// client
export const apiClientsNotesPhotos = `${prefixAdminApiV2}/clients/notes/photos`
export const apiClientsNotesPhotosId = `${prefixAdminApiV2}/clients/notes/photos/:id`
export const apiClientsNotesClientId = `${prefixAdminApiV2}/clients/notes/:clientId`
export const apiClientsNotesClientIdNoteId = `${prefixAdminApiV2}/clients/notes/:clientId/:noteId`

// service charges
export const apiServiceCharges = `${prefixAdminApiV2}/service-charges`
export const apiServiceChargesId = `${prefixAdminApiV2}/service-charges/:id`

// leave
export const apiLeavePolicies = `${prefixAdminApiV2}/leave-policies`
export const apiLeavePoliciesId = `${prefixAdminApiV2}/leave-policies/:id`
export const apiLeaveAssignments = `${prefixAdminApiV2}/leave-assignments`
export const apiLeaveAssignmentsId = `${prefixAdminApiV2}/leave-assignments/:id`
export const apiLeaveBalances = `${prefixAdminApiV2}/leave-balances`
export const apiLeaveBalancesMe = `${prefixAdminApiV2}/leave-balances/me`
export const apiLeaveBalancesLedger = `${prefixAdminApiV2}/leave-balances/ledger`
export const apiLeaveBalancesMeLedger = `${prefixAdminApiV2}/leave-balances/me/ledger`
export const apiLeaveBalancesAdjust = `${prefixAdminApiV2}/leave-balances/adjust`
export const apiLeaveRequests = `${prefixAdminApiV2}/leave-requests`
export const apiLeaveRequestsMe = `${prefixAdminApiV2}/leave-requests/me`
export const apiLeaveRequestsPreview = `${prefixAdminApiV2}/leave-requests/preview`
export const apiLeaveRequestsId = `${prefixAdminApiV2}/leave-requests/:id`
export const apiLeaveRequestsIdApprove = `${prefixAdminApiV2}/leave-requests/:id/approve`
export const apiLeaveRequestsIdReject = `${prefixAdminApiV2}/leave-requests/:id/reject`
export const apiLeaveRequestsIdCancel = `${prefixAdminApiV2}/leave-requests/:id/cancel`
export const apiLeaveCalendar = `${prefixAdminApiV2}/leave-calendar`

// payments
export const apiPayments = `${prefixAdminApiV2}/branches/:branch/payments`

// expenses
export const apiExpensesCategories = `${prefixAdminApiV2}/expenses/categories`
export const apiExpensesCategoriesId = `${prefixAdminApiV2}/expenses/categories/:id`
export const apiBranchExpenses = `${prefixAdminApiV2}/branches/:branch/expenses`
export const apiBranchExpensesId = `${prefixAdminApiV2}/branches/:branch/expenses/:id`

// analytics
export const apiBranchAnalyticsSummarySales = `${prefixAdminApiV2}/branches/:branch/analytics/summary-sales`
export const apiBranchAnalyticsSummaryItemSales = `${prefixAdminApiV2}/branches/:branch/analytics/summary-item-sales`

export const apiBranchTransactionOpenPayment = `${prefixAdminApiV2}/branches/:branch/transactions/:id/open-payment`
export const apiBranchTransactionCancelPayment = `${prefixAdminApiV2}/branches/:branch/transactions/:id/cancel-payment`
export const apiBranchTransactionOpenPaymentDetails = `${prefixAdminApiV2}/branches/:branch/transactions/:id/open-payment/details`

//loyalty
export const apiLoyaltiesConfig = `${prefixAdminApiV2}/loyalties/configs`
export const apiLoyaltiesConfigEarningMethods = `${prefixAdminApiV2}/loyalties/configs/earning-methods`
export const apiLoyaltiesConfigRewards = `${prefixAdminApiV2}/loyalties/configs/rewards`
export const apiLoyaltiesConfigRewardsClientsId = `${prefixAdminApiV2}/loyalties/configs/rewards/clients/:id`
export const apiLoyaltiesConfigRewardsId = `${prefixAdminApiV2}/loyalties/configs/rewards/:id`

export const apiLoyaltiesClientId = `${prefixAdminApiV2}/loyalties/clients/:id`
export const apiLoyaltiesClientIdPoints = `${prefixAdminApiV2}/loyalties/clients/:id/points`
export const apiLoyaltiesClientIdTiers = `${prefixAdminApiV2}/loyalties/clients/:id/tiers`
export const apiLoyaltiesPointsHistoriesId = `${prefixAdminApiV2}/loyalties/points/histories/:id`
export const apiLoyaltiesTiersHistoriesId = `${prefixAdminApiV2}/loyalties/tiers/histories/:id`

// tiers
export const apiLoyaltiesTiersConfig = `${prefixAdminApiV2}/loyalties/tiers/configs`
export const apiLoyaltiesTiers = `${prefixAdminApiV2}/loyalties/tiers`
export const apiLoyaltiesTiersId = `${prefixAdminApiV2}/loyalties/tiers/:id`

// bundles
export const apiBundles = `${prefixAdminApiV2}/bundles`
export const apiBundlesId = `${prefixAdminApiV2}/bundles/:id`

// printer configs
export const apiPrinterConfigs = `${prefixAdminApiV2}/printer/configs`

// attendance
export const apiBranchAttendanceConfig = `${prefixAdminApiV2}/branches/:branch/attendances/configs`
export const apiAttendanceUserConfigId = `${prefixAdminApiV2}/attendances/users/configs/:id`
export const apiAttendanceUserConfigFaceId = `${prefixAdminApiV2}/attendances/users/configs/faces`
export const apiBranchesSchedulesToday = `${prefixAdminApiV2}/branches/:branch/schedules/today/me`
export const apiBranchesAttendanceToday = `${prefixAdminApiV2}/branches/:branch/attendances/todays`
export const apiBranchesAttendance = `${prefixAdminApiV2}/branches/:branch/attendances`
export const apiBranchesAttendanceId = `${prefixAdminApiV2}/branches/:branch/attendances/:id`

export const apiBranchesAttendanceIdApprove = `${prefixAdminApiV2}/branches/:branch/attendances/:id/approve`

export const apiServiceUsersCommissions = `${prefixAdminApiV2}/services/users/commissions/:userId`

// vouchers
export const apiVouchers = `${prefixAdminApiV2}/vouchers`
export const apiVouchersId = `${prefixAdminApiV2}/vouchers/:id`

// service materials (inventory)
export const apiServiceMaterials = `${prefixAdminApiV2}/service-materials`
export const apiServiceMaterialsId = `${prefixAdminApiV2}/service-materials/:id`
export const apiBranchesServiceMaterials = `${prefixAdminApiV2}/branches/:branch/service-materials`
export const apiBranchesServiceMaterialsIdStocksAdd = `${prefixAdminApiV2}/branches/:branch/service-materials/:id/stocks/add`
export const apiBranchesServiceMaterialsIdStocksRemove = `${prefixAdminApiV2}/branches/:branch/service-materials/:id/stocks/remove`
export const apiBranchesServiceMaterialsIdStocksThreshold = `${prefixAdminApiV2}/branches/:branch/service-materials/:id/stocks/threshold`
export const apiBranchesServiceMaterialsIdStocksStocktake = `${prefixAdminApiV2}/branches/:branch/service-materials/:id/stocks/stocktake`
export const apiBranchesServiceMaterialsIdStocksHistories = `${prefixAdminApiV2}/branches/:branch/service-materials/:id/stocks/histories`
export const apiServicesIdMaterialRecipe = `${prefixAdminApiV2}/services/:id/material-recipe`

// whatsapp official api
export const apiWhatsappApiBalance = `${prefixAdminApiV2}/whatsapp-api/balance`
export const apiWhatsappApiBalanceHistory = `${prefixAdminApiV2}/whatsapp-api/balance/history`
export const apiWhatsappApiTopups = `${prefixAdminApiV2}/whatsapp-api/topups`
export const apiWhatsappApiTopupPending = `${prefixAdminApiV2}/whatsapp-api/topups/pending`
export const apiWhatsappApiTopupId = `${prefixAdminApiV2}/whatsapp-api/topups/:id`
export const apiWhatsappApiTopupIdCancel = `${prefixAdminApiV2}/whatsapp-api/topups/:id/cancel`
export const apiWhatsappApiMessages = `${prefixAdminApiV2}/whatsapp-api/messages`
export const apiWhatsappApiMessagesId = `${prefixAdminApiV2}/whatsapp-api/messages/:id`
export const apiWhatsappApiMessagesIdResend = `${prefixAdminApiV2}/whatsapp-api/messages/:id/resend`
export const apiWhatsappApiTemplates = `${prefixAdminApiV2}/whatsapp-api/templates`
export const apiWhatsappApiTemplateSelections = `${prefixAdminApiV2}/whatsapp-api/template-selections`
